// Pulls every row of a paginated list in chunks (default 500 per request).
//
// source.fetchPage(page, perPage) must resolve { rows, lastPage, total }.
// Returns a controller: { promise, cancel() }. onProgress({ loaded, total, page, lastPage }).
export function fetchAll(source, { perPage = 500, max = 50000, onProgress } = {}) {
  var cancelled = false;
  var promise = (async function () {
    var rows = [];
    var page = 1;
    var lastPage = 1;
    var total = 0;
    do {
      if (cancelled) throw new Error('cancelled');
      var res = await source.fetchPage(page, perPage);
      rows = rows.concat(res.rows || []);
      lastPage = res.lastPage || 1;
      total = res.total || rows.length;
      if (onProgress) onProgress({ loaded: rows.length, total: total, page: page, lastPage: lastPage });
      page++;
    } while (page <= lastPage && rows.length < max);
    if (cancelled) throw new Error('cancelled');
    return { rows: rows, total: total, truncated: rows.length < total };
  })();
  return {
    promise: promise,
    cancel: function () {
      cancelled = true;
    },
  };
}
